import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { setformmodal } from '../../redux/formslice';
import { setotpmodal,setprofilenotupdate } from '../../redux/formslice';
import Register from './Register';
import Login from './Login';
import ForgotPssword from './ForgotPssword'
import { AddressForm } from '../Common';
import { IoClose } from "react-icons/io5";
import OTPVerification from './OtpVerifiaction';

function Example() {
    const formmodal = useSelector((state) => state.formslice.formmodal)
    const optmodalopen = useSelector((state) => state.formslice.optmodalopen)
    const formstatus = useSelector((state) => state.formslice.formstatus);
    const profilenotupdate = useSelector((state) => state.formslice.profilenotupdate);
    const dispatch = useDispatch()
    const otpmodalhandle =()=>{
        dispatch(setotpmodal(!optmodalopen))
        dispatch(setprofilenotupdate(!profilenotupdate))
    }

    const handleClose = () =>  dispatch(setotpmodal(false));
    const handleClose1 = () =>  dispatch(setformmodal(false));

    return (
        <>
            <Modal
                show={formmodal}
                onHide={handleClose1}
                keyboard={false}
                size={formstatus == 3 && "lg"}
                centered
                className={optmodalopen && 'z-3'}
            >
                <div className='modalclose d-flex cursor-pointer justify-content-end pe-2 pt-2 '>
                    <IoClose size={20} onClick={() => { dispatch(setformmodal(!formmodal)) }} />
                </div>

                {
                    formstatus == 1 &&
                    <Login />
                }
                {
                    formstatus == 2 &&
                    <Register />
                }
                {
                    formstatus == 3 &&
                    <AddressForm />
                }
                {
                    formstatus ==4 &&
                    <ForgotPssword />
                }



            </Modal>
            
            <Modal
                show={optmodalopen}
                onHide={handleClose}
                keyboard={false}
                centered
            >
                <div className='modalclose cursor-pointer d-flex justify-content-end pe-2 pt-2 '>
                    <IoClose size={20} onClick={ otpmodalhandle} />
                </div>
                <OTPVerification />

            </Modal>
        </>
    );
}

export default Example;